<template>
  <section class="about-container">
    <div class="container pt-0 pb-0">
      <div class="section-content" data-aos="fade-left" data-aos-delay="300">
        <div class="row equal-height-inner about-box">
          <div
            class="col-sm-6 col-md-6 col-lg-3 pr-0 pr-sm-15 p-xs-0 sm-height-auto mt-sm-0"
          >
            <div class="sm-height-auto bg-theme-colored">
              <div class="p-30 p-sm-20">
                <div class="icon-about">
                  <i class="fa fa-stethoscope text-theme-colored"></i>
                </div>
                <h3 class="text-uppercase text-white mt-0">
                  Tenaga Profesional
                  <br />
                  <small class="text-gray-lighter">Dokter & Tenaga Medis</small>
                </h3>
                <p class="text-white">
                  Rumah Sakit UII memiliki dokter spesialis dan tenaga medis
                  yang profesional di bidangnya sehingga mampu memberikan
                  pelayanan kesehatan yang paripurna.
                </p>
                <b-link
                  :to="{ path: '/jadwal-dokter' }"
                  class="btn btn-border btn-circled btn-transparent btn-sm"
                  >Jadwal Dokter</b-link
                >
              </div>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-6 col-lg-3 pl-0 pl-sm-15 pr-0 pr-sm-15 p-xs-0 sm-height-auto mt-sm-0"
          >
            <div class="sm-height-auto bg-theme-colored2">
              <div class="p-30 p-sm-20">
                <div class="icon-about">
                  <i class="fa fa-clock-o text-theme-colored"></i>
                </div>
                <h3 class="text-uppercase text-white mt-0">
                  Jam Pelayanan Rawat Jalan
                </h3>
                <div class="opening-hours">
                  <ul class="list-unstyled text-white">
                    <li class="clearfix">
                      <span>Senin - Minggu</span>
                      <div class="value">Jam 08.00 - 21.00 WIB</div>
                    </li>
                  </ul>
                </div>
                <b-link
                  class="btn btn-border btn-circled btn-transparent btn-sm mt-20"
                  :to="{ path: '/rawat-jalan' }"
                  >Daftar Online</b-link
                >
              </div>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-6 col-lg-3 pl-0 pr-0 pl-sm-15 pr-sm-15 p-xs-0 sm-height-auto mt-sm-0"
          >
            <div class="sm-height-auto bg-theme-colored">
              <div class="p-30 p-sm-20">
                <div class="icon-about">
                  <i class="fa fa-wheelchair text-theme-colored"></i>
                </div>
                <h3 class="text-uppercase text-white mt-0">
                  Layanan Lengkap & Modern
                  <br />
                </h3>
                <p class="text-white">
                  Rumah Sakit UII berkomitmen memberikan pelayanan yang lengkap,
                  modern, dan ramah kepada semua pengunjung yang datang.
                </p>
                <b-link
                  :to="{ path: '/penunjang-medis' }"
                  class="btn btn-border btn-circled btn-transparent btn-sm"
                  >Layanan</b-link
                >
              </div>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-6 col-lg-3 pl-0 pl-sm-15 p-xs-0 sm-height-auto mt-sm-0"
          >
            <div class="sm-height-auto bg-theme-colored2">
              <div class="p-30 p-sm-20">
                <div class="icon-about">
                  <i class="fa fa-phone text-theme-colored"></i>
                </div>
                <h3 class="text-uppercase text-white mt-0">
                  24 Jam IGD
                  <br />
                  <small class="text-gray-lighter">Emergency Call</small>
                </h3>
                <h2 class="text-white">281-2111</h2>
                <p class="text-white">
                  Layanan Instalasi Gawat Darurat (IGD) 24/7. Siap membantu dan
                  melayani anda dengan sepenuh hati.
                </p>
                <b-link
                  :to="{ path: '/contact' }"
                  class="btn btn-border btn-circled btn-transparent btn-sm"
                  >Kontak</b-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container about-detail-container"
      data-aos="fade-left"
      data-aos-delay="300"
    >
      <div class="section-content">
        <div class="row">
          <div class="col-md-5">
            <img v-bind:src="image" alt class="img-about" />
          </div>
          <div class="col-md-7 mt-xs-30">
            <!-- <h2 class="mt-0">Kenapa Memilih <span class="text-theme-colored"> Kami</span></h2> -->

            <i
              v-if="show_loading"
              class="fa fa-spinner fa-spin fa-3x fa-fw"
            ></i>
            <div v-else v-html="content"></div>

            <b-link
              v-if="!show_loading"
              :to="{ path: '/about-us' }"
              class="btn btn-theme-colored btn-lg btn-circled mt-30"
              >Lihat Selengkapnya</b-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../../services/api";

export default {
  data() {
    return {
      show_loading: true,
      content: "",
      image: ""
    };
  },
  mounted() {
    this.getAbout();
  },
  methods: {
    getAbout() {
      api
        .post(api.route.get.page, {
          slug: "about-us"
        })
        .then(res => {
          let status = res.status;
          if (status) {
            let data = res.data;
            let dataJson = JSON.parse(data.meta);
            let regex = /(<([^>]+)>)/gi;
            let content = data.content.replace(regex, "");
            this.show_loading = false;
            // prettier-ignore
            this.image = dataJson.meta_picture == null ? "../assets/no-image.jpg" : dataJson.meta_picture;
            this.content = content.substr(0, 400) + "...";
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style>
.img-about {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeAbout.vue